import { Routes, Route } from 'react-router-dom';

const InClass = ({data}) => {

  /////////////////////////
  // render
  /////////////////////////
  return (
    <>
      <Routes>
        <Route path='/' element={
          <div className="flex flex-col mt-6 mx-8 space-y-6 md:tracking-wide">
            <div className="p-3 rounded bg-cod-gray-mid relative">
              {data.map((value, i) =>
                <div key={i} className="flex flex-row justify-between bg-cod-gray p-3 my-1 w-full">
                  <div className="flex flex-row">
                    <div className="mr-3">{new Date(value.date).toLocaleDateString('en-us', { weekday:"short", month:"short", day:"numeric"})}</div>
                    <div>{value.title} {value.comment && <><em>({value.comment})</em></>}</div>
                  </div>
                  <div>{value.max_score > 0 ? <>{value.score.toFixed(2)} / {value.max_score.toFixed(2)}</> : <>&nbsp;{value.score}</>}</div>
                </div>
              )}
            </div>
          </div>} />
      </Routes>
    </>
  );
};

export default InClass;
